import { checklist_notification } from "../../utils/endpoints";

export default function EmailChose({ check_list_id, context, setContext }) {
  const handleSubmit = async (e) => {
    e.preventDefault();
    setContext({ loader: true });
    const response = await context.httpRequest(
      "post",
      checklist_notification.replace("*", check_list_id),
      { email: e.target.email.value },
      context.session.token
    );
    if (response.result) {
      context.openMessage("success", "Email inviata correttamente!");
      handleClose();
    }
    setContext({ loader: false });
  };

  const handleClose = () => {
    document.querySelector("#close-modal-button").click();
  };

  return (
    <form onSubmit={(e) => handleSubmit(e)} className="w-100 mx-auto">
      <small>
        Inserisci uno o più indirizzi email saparati dal carattere "," ai quali
        inviare una versione stampabile di questa checklist
      </small>
      <label className="d-block mt-3">EMAIL</label>
      <input
        name="email"
        type="text"
        className="w-100"
        placeholder="Scrivi le email separate da una virgola"
        required
      />
      <div className="text-end mt-5">
        <button
          type="button"
          className="q8-blue-button py-2 px-3 ms-auto me-3"
          onClick={() => handleClose()}
        >
          ANNULLA
        </button>
        <button type="submit" className="q8-blue-button py-2 px-3">
          INVIA CHECKLIST
        </button>
      </div>
    </form>
  );
}
